
import React from 'react';
import Photos from '../components/Photos';
import Footer from '../components/Footer';


function PhotosPage() {
  return (
    <>
        <Photos />
        <Footer />
    </>
  );
}


export default PhotosPage;